import { TimeSpan } from "@sparkware/app-utils";

export interface ImagePreloadPromiseResponse {
    error: string | null;
    backgroundUrl: string;
    imageObj: HTMLImageElement;
}

export function imagePreload(src: string, timeout?: TimeSpan) {
    timeout = timeout || TimeSpan.fromMinutes(2);
    let timeoutRef: any = null;
    return new Promise<ImagePreloadPromiseResponse>((res, rej) => {
        let image = new Image();
        image.onload = () => {
            clearTimeout(timeoutRef);
            res({error: null, backgroundUrl: src, imageObj: image});
        };
        image.onerror = ()=> {
            clearTimeout(timeoutRef);
            rej({
                error: 'Could not load image on path => ' + src,
                backgroundUrl: src
            });
        };
        timeoutRef = setTimeout(() => {
            rej({
                error: 'Timeout. Could not load image on path => ' + src,
                backgroundUrl: src
            });
        }, timeout.totalMilliseconds);
        image.src = src;
    });
}

export function imagePreloadWithDefault(src: string | null | undefined, defaultPath: string) {
    if (src) {
        return imagePreload(src).catch(() => {
            return imagePreload(defaultPath);
        });
    } else {
        return imagePreload(defaultPath);
    }
}
